import createSeriesMetadata from './createSeriesMetadata';

function createStudyMetadata(StudyInstanceUID) {
  return {
    StudyInstanceUID,
    StudyDescription: '',
    ModalitiesInStudy: [],
    isLoaded: false,
    series: [],
    /**
     * @param {object} instance
     */
    addInstanceToSeries: function (instance) {
      this.addInstancesToSeries([instance]);
    },
    /**
     * @param {object[]} instances
     * @param {string} instances[].SeriesInstanceUID
     * @param {string} instances[].StudyDescription
     */
    addInstancesToSeries: function (instances) {
      const { SeriesInstanceUID } = instances[0];
      const firstInstance = instances[0];

      if (!this.StudyDescription && firstInstance.StudyDescription) {
        this.StudyDescription = firstInstance.StudyDescription;
      }

      if (!this.StudyDate && firstInstance.StudyDate) {
        this.StudyDate = firstInstance.StudyDate;
      }

      if (!this.StudyID && firstInstance.StudyID) {
        this.StudyID = firstInstance.StudyID;
      }

      if (!this.AccessionNumber && firstInstance.AccessionNumber) {
        this.AccessionNumber = firstInstance.AccessionNumber;
      }

      let series = this.series.find(s => s.SeriesInstanceUID === SeriesInstanceUID);

      if (!series) {
        series = createSeriesMetadata(SeriesInstanceUID);
        this.series.push(series);
      }

      series.addInstances(instances);
    },

    setSeriesMetadata: function (SeriesInstanceUID, seriesMetadata) {
      let existingSeries = this.series.find(s => s.SeriesInstanceUID === SeriesInstanceUID);

      if (existingSeries) {
        existingSeries = Object.assign(existingSeries, seriesMetadata);
      } else {
        const series = createSeriesMetadata(SeriesInstanceUID);
        this.series.push(Object.assign(series, seriesMetadata));
      }
    },
  };
}

export default createStudyMetadata;
